/**
 * Aligné sur `ReservationModal` / `getChampsForMode` : champs_saisie peut être JSON string.
 * @param {object} method — ligne renvoyée par `UserApi.getPaymentMethodsByUserId`
 * @returns {object|null}
 */
export function normalizeUserPaymentMethodForPicker(method) {
  if (!method || method.id == null) return null;
  let champs = method.champs_saisie;
  if (typeof champs === 'string') {
    try {
      champs = JSON.parse(champs);
    } catch {
      champs = [];
    }
  }
  if (!Array.isArray(champs)) champs = [];
  return { ...method, champs_saisie: champs };
}

/** Libellé option (même logique que `getModeLabelById` dans ReservationModal). */
export function getUserPaymentMethodOptionLabel(mode, t) {
  if (!mode) return '';
  const modeLabel = mode.label || mode.libelle || mode.code || '';
  if (!t || typeof t !== 'function') return modeLabel || `Mode #${mode.id}`;
  const translationKey = `paymentModes.${modeLabel}`;
  const translation = t(translationKey, { defaultValue: modeLabel });
  return translation === translationKey ? modeLabel : translation;
}
